<template>
	<LineChart
		:chart-id="chartId"
		:chart-data="chartData"
		class="width-100 height-100"
		:chart-options="chartOptions"
		:dataset-id-key="datasetIdKey"
	/>
</template>

<script>
import LineChart from '@/components/Charts/LineChart.vue';

export default {
	name: 'AnalyticsLineChart',
	components: { LineChart },
	props: {
		data: { type: Array, default: () => [] },
		labels: { type: Array, default: () => [] },
		chartId: { type: String, default: 'line-chart' },
		datasetIdKey: { type: String, default: 'label' },
	},
	computed: {
		chartData() {
			return {
				labels: this.labels,
				datasets: [
					{
						fill: 'start',
						data: this.data,
						borderColor: '#3C6EF4',
						backgroundColor: (context) => {
							const ctx = context.chart.ctx;
							const gradient = ctx.createLinearGradient(0, 5, 0, 55); // (x0, y0, x1, y1) => from (0,5) to (0,55)
							gradient.addColorStop(0, '#D4DFFD');
							gradient.addColorStop(1, '#FDFEFF');
							return gradient;
						},
					},
				],
			};
		},
	},
	data() {
		return {
			chartOptions: {
				animate: true,
				responsive: true,
				maintainAspectRatio: false,
				layout: { padding: { bottom: 10 } },
				plugins: { legend: { display: false } },
				elements: { line: { tension: 0.5, borderWidth: 2 }, point: { radius: 0 } },
				scales: { x: { display: false }, y: { display: false, beginAtZero: true } },
			},
		};
	},
};
</script>
